<app-headersecond></app-headersecond>
<section class="section about">
  <div class="container"> 
    <div class="section-box-about">
      <div>
       <p class="text-h3">Editar</p><p class="text-h2"> descripcion del About </p>
        <form *ngIf="aboutForm" [formGroup]="aboutForm" (ngSubmit)="onSubmit()">
            <mat-form-field  class="custom-mat-input">
              <mat-label class="cine">Descripción</mat-label>
              <textarea class="custom-textarea" maxlength="120" matInput matTextareaAutosize matAutosizeMinRows="6" matAutosizeMaxRows="10"  placeholder="description" formControlName="description"></textarea>
              <div class="mat-hint-div">
              <mat-hint class="mat-hint" align="end">
                {{120 - aboutForm.controls.description?.value.length}} caracteres restantes
              </mat-hint></div>
            </mat-form-field>
            <div class="mb-0">
              <mat-form-field  class="custom-mat-input">
                <mat-label class="cine">Url de Imagen</mat-label>
                <textarea class="custom-textarea2" maxlength="300" matInput matTextareaAutosize matAutosizeMinRows="6" matAutosizeMaxRows="10"  placeholder="img_url" formControlName="img_url"></textarea>
                <div class="mat-hint-div">
                <mat-hint class="mat-hint" align="end">
                  {{300 - aboutForm.controls.img_url?.value.length}} caracteres restantes
                </mat-hint></div>
              </mat-form-field>
            </div>
            <div *ngIf="aboutForm.controls.description.invalid && aboutForm.controls.description.touched" class="text-danger">
              <div *ngIf="aboutForm.controls.description.errors.required">La descripción es obligatoria.</div>
            </div>
            <div class="mb-0">
              <button class="main-btn" type="submit" [disabled]="aboutForm.invalid" [ngClass]="{'disabled-button':aboutForm.invalid}">Guardar cambios</button>
            </div>
          </form>
          
        </div>
      </div>
    </div>
  </section>
